export default __webpack_public_path__ + "static/media/shuttle.b23deb8b.png";